import { useEffect } from 'react'
import { globalHistory } from '@reach/router'

const scrollIntoView = (el, offset = 0) => {
  if (el) {
    const { top } = el.getBoundingClientRect()
    if (top < 0) {
      window.scrollBy({ top: top - offset, left: 0, behavior: 'smooth' })
    }
  }
}

const useScrollIntoView = (ref, offset = 0) => {
  useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === 'PUSH') {
        scrollIntoView(ref.current, offset)
      }
    })
  }, [ref, offset])
}

export default useScrollIntoView
